import { collection, query, where, orderBy, limit, QueryConstraint } from 'firebase/firestore';
import { getDb } from './firestoreDb';
import { QueryFilter, QueryOrder, QueryConfig } from './types';

/**
 * Builds Firestore query constraints from configuration
 */
export function buildQueryConstraints(config: QueryConfig): QueryConstraint[] {
  const constraints: QueryConstraint[] = [];

  // Add where clauses
  if (config.filters) {
    for (const filter of config.filters) {
      constraints.push(where(filter.field, filter.operator, filter.value));
    }
  }

  // Add orderBy clauses
  if (config.orderBy) {
    for (const order of config.orderBy) {
      constraints.push(orderBy(order.field, order.direction || 'asc'));
    }
  }

  // Add limit
  if (config.limit !== undefined) {
    constraints.push(limit(config.limit));
  }

  return constraints;
}

/**
 * Builds a complete Firestore query from collection name and configuration
 */
export function buildQuery(collectionName: string, config: QueryConfig) {
  const constraints = buildQueryConstraints(config);
  return query(collection(getDb(), collectionName), ...constraints);
}
